// Dropping files on the Sessions pane starts a session (today's Home drop
// handler, d43):
//   - a drag of ours (application/x-cloudloop-sound) starts nothing: no
//     overlay, no session
//   - a ZIP, .als or .alp (or a zip type) is imported (stageNewSessionArchive)
//   - otherwise lossless audio (.wav .aif .aiff .aifc .flac, or any audio/*)
//     is staged (stageNewSessionAudio)
//   - a drop with no audio and no archive still opens New session
// The picker in New session accepts the same types.

export const OWN_DRAG_TYPE = "application/x-cloudloop-sound";
export const ACCEPT = ".zip,.als,.alp,.wav,.aif,.aiff,.aifc,.flac";

export const isArchive = (f) =>
  !!f &&
  (/\.(zip|als|alp)$/i.test(f.name || "") || f.type === "application/zip" || f.type === "application/x-zip-compressed");

export const isAudio = (f) => !!f && (/\.(wav|aif|aiff|aifc|flac)$/i.test(f.name || "") || /^audio\//.test(f.type || ""));

const typesOf = (dt) => Array.from((dt && dt.types) || []);

// A drag of ours, dropped back on cloudloop (d43).
export const isOwnDrag = (dt) => typesOf(dt).includes(OWN_DRAG_TYPE);

// Files from the desktop (and not one of our own drags).
export const carriesFiles = (dt) => !isOwnDrag(dt) && typesOf(dt).includes("Files");

/**
 * What a drop does: { kind: "ignore" } for our own drags, { kind:
 * "archive", file }, { kind: "audio", files }, or { kind: "open" } (no
 * audio and no archive: New session opens anyway).
 */
export function classifyDrop(dt) {
  if (isOwnDrag(dt)) return { kind: "ignore" };
  const files = Array.from((dt && dt.files) || []);
  if (!files.length && !typesOf(dt).includes("Files")) return { kind: "ignore" };
  const archive = files.find(isArchive);
  if (archive) return { kind: "archive", file: archive };
  const audio = files.filter(isAudio);
  if (audio.length) return { kind: "audio", files: audio };
  return { kind: "open" };
}

// Act on a drop through the store's frozen actions. Returns the kind.
export function routeDrop(dt, store) {
  const d = classifyDrop(dt);
  if (d.kind === "archive") store.dispatch("stageNewSessionArchive", d.file);
  else if (d.kind === "audio") store.dispatch("stageNewSessionAudio", d.files);
  else if (d.kind === "open") store.dispatch("setShowDialog", true);
  return d.kind;
}
